<template>
  <v-container>
    <static-page-content uri="/static/pages/auth" />
    <api-key-form />
  </v-container>
</template>
<script>
export default {
  name: 'AuthPage'
}
</script>



// WEBPACK FOOTER //
// src/pages/auth.vue